import { MediaPipeline } from '@optools/services/operator-gateway/types/generated/graphql';

export const getIsInAdBreak = (
  adBreakStartedDateTime: MediaPipeline['adBreakStartedDateTime'],
  adBreakDurationInSeconds: MediaPipeline['adBreakDurationInSeconds'],
) => {
  return typeof adBreakDurationInSeconds === 'number' && !!adBreakStartedDateTime;
};
